module.exports = __webpack_public_path__ + "img/satelite.7d3225e7.webp";